export default "__VITE_ASSET__8a302d5e__"